// Worker prewarm helper for heavy source entries.
// It reduces first worker compile latency when auto/forced strategy already predicts offload.
import { ensureRuntimeFeatures, getRuntimeFeature } from '../../features'
import { readLuisRuntimeOptions } from '../options'
import type { BuildSourceEntry } from './types'
import { resolveCompileExecution } from '../../compile-dispatch/strategy'

// Prewarm worker host when current entry set already predicts worker execution.
export async function prewarmWorkerForPredictedEntries(entries: BuildSourceEntry[]): Promise<void> {
  // Skip prewarm when no current source is likely to use worker compile.
  if (!entries.some((entry) => resolveCompileExecution(entry, { worker: readLuisRuntimeOptions(entry.source).worker }) === 'worker')) {
    return
  } else {
    // Continue worker feature warmup for predicted heavy compile.
  }

  await ensureRuntimeFeatures(new Set(['worker']))
  const workerFeature = getRuntimeFeature('worker')
  // Skip warmup when worker bundle could not be loaded.
  if (!workerFeature) {
    return
  } else {
    // Continue compile worker warmup.
  }

  await workerFeature.warmup()
}
